var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_wrapper container-fluid job_opening_area"},[_c('div',{staticClass:"row page_header job_opening_header"},[_c('job-opening-header',{attrs:{"current-breadcrumb-items":_vm.jobOpeningBreadcrumb,"title":"職缺搜尋"}})],1),_vm._v(" "),_c('div',{staticClass:"row job_opening_content"},[_c('job-opening-zh-details-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }